module.exports = __webpack_public_path__ + "images/e8b5262c0b961f43c93f9952cba2d503-fishemanswharf.jpg";